export default __webpack_public_path__ + "static/media/htm.6f674f12.svg";